export const getEditPermissionByPath = (path, menuList, privileges) => {
  // Recursive function to search menu item by path
  const findMenuItemByPath = (items) => {
    for (const item of items) {
      if (item.path === path) return item;
      if (item.subMenu) {
        const found = findMenuItemByPath(item.subMenu);
        if (found) return found;
      }
    }
    return null;
  };

  const menuItem = findMenuItemByPath(menuList);

  if (!menuItem) return null; // path not found

  const matchedPrivilege = privileges.find((priv) =>
    priv.ModuleName === menuItem.label || priv.ScreenName === menuItem.label
  );

  return matchedPrivilege ? matchedPrivilege.Edit : null;
};

export const getAccessPath = (path, menuList, privileges) => {
  const findMenuItemByPath = (items) => {
    for (const item of items) {
      if (item.path === path) return item;
      if (item.subMenu) {
        const found = findMenuItemByPath(item.subMenu);
        if (found) return found;
      }
    }
    return null;
  };
  const menuItem = findMenuItemByPath(menuList);
  if (!menuItem) return false;

  const matchedPrivilege = privileges.find((priv) =>
    priv.ModuleName === menuItem.label || priv.ScreenName === menuItem.label
  );

  return matchedPrivilege ? false : true;
  };

  export const formatDate = (date) => {
  if (!date) return "";
  return date.split("T")[0];
};

  export const getUserPermissions = () => {
    if (typeof window === "undefined") {
      return null;
    }
  
    const Privilliages = localStorage.getItem("Privilliages");
    if(Privilliages === "undefined") return null
    const decoded = JSON.parse(Privilliages);
    return decoded
  }; 

  export const getValidLogo = (val, fallback) =>
  val && val !== "null" && val !== "undefined" && val !== "" ? val : fallback;

  // Convert number to words with dynamic currency subunit (e.g., cents, paisa, fils)
  export function convertToMoneyWords(num, currencyCode = "") {
    const currencySubunits = {
      USD: "Cents",
      UGX: "Shilling",
      INR: "Paisa",
      AED: "Fils",
      EUR: "Cents",
      GBP: "Pence",
      KES: "Cents",
      TZS: "Cents",
      CAD: "Cents",
      AUD: "Cents",
      ZAR: "Cents",
      NGN: "Kobo",
      PKR: "Paisa",
      BDT: "Paisa",
      LKR: "Cents",
      default: "Cents",
    };

    if (isNaN(num)) return "Invalid amount";
    if (num === 0) return `${currencyCode} Zero Only`;

    const subunit = currencySubunits[currencyCode] || currencySubunits.default;
    const isNegative = num < 0;
    num = Math.abs(num);

    const units = ["", "Thousand", "Million", "Billion"];
    const ones = ["", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine"];
    const teens = ["Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"];
    const tens = ["", "Ten", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];

    const [wholePart, decimalPart] = num.toFixed(2).split(".");
    let wholeWords = [];
    let decimalWords = [];

    function convertTwoDigits(n) {
      if (n < 10) return ones[n];
      if (n < 20) return teens[n - 10];
      const ten = Math.floor(n / 10);
      const unit = n % 10;
      return tens[ten] + (unit ? "-" + ones[unit] : "");
    }

    function convertThreeDigits(n) {
      if (n === 0) return "";
      let words = [];
      const hundreds = Math.floor(n / 100);
      const remainder = n % 100;
      if (hundreds > 0) words.push(ones[hundreds] + " Hundred");
      if (remainder > 0) words.push(convertTwoDigits(remainder));
      return words.join(" ");
    }

    if (parseInt(wholePart, 10) > 0) {
      let chunkIndex = 0;
      let remaining = parseInt(wholePart, 10);
      while (remaining > 0) {
        const chunk = remaining % 1000;
        if (chunk !== 0) {
          let chunkWords = convertThreeDigits(chunk);
          if (units[chunkIndex]) chunkWords += " " + units[chunkIndex];
          wholeWords.unshift(chunkWords);
        }
        remaining = Math.floor(remaining / 1000);
        chunkIndex++;
      }
    } else {
      wholeWords.push("Zero");
    }

    if (parseInt(decimalPart, 10) > 0 && subunit) {
      decimalWords.push(convertTwoDigits(parseInt(decimalPart, 10)) + " " + subunit);
    }

    let result = "";
    if (isNegative) result += "Minus ";
    if (currencyCode) result += currencyCode + " ";
    result += wholeWords.join(" ");
    if (decimalWords.length) result += " and " + decimalWords.join(" ");
    result += " Only";

    return result.replace(/\s+/g, " ").trim();
  }